import { render, staticRenderFns } from "./salesInstallmentsItem.vue?vue&type=template&id=d8633952&"
import script from "./salesInstallmentsItem.vue?vue&type=script&lang=js&"
export * from "./salesInstallmentsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports